"use client"

import type { MfaMethod } from "@opensea/embedded-wallet-sdk"
import { checkMfaEnrollment } from "@opensea/embedded-wallet-sdk"
import { useMountEffect } from "@opensea/ui-kit/hooks"
import { useState } from "react"

export const useMfaMethods = () => {
  const [loading, setLoading] = useState(true)
  const [mfaMethods, setMfaMethods] = useState<MfaMethod[]>([])

  const doMfaEnrollmentCheck = async (retryCount = 0) => {
    // Limit retries
    if (retryCount > 30) {
      console.error("Failed to check MFA enrollment")
      setLoading(false)
      return
    }

    // Check MFA enrollment
    const response = await checkMfaEnrollment()
    if (response.isReady) {
      setMfaMethods(response.mfaMethods)
      setLoading(false)
    } else {
      // Retry every second until the privy user is ready
      setTimeout(() => doMfaEnrollmentCheck(retryCount + 1), 1000)
    }
  }

  useMountEffect(() => {
    doMfaEnrollmentCheck()
  })

  return { mfaMethods, loading, reload: doMfaEnrollmentCheck }
}
